import React, { Component } from 'react';

class InnerFeature extends Component {

  render() {
    return (
      <div>
      	<div className={'benefit inner-benefit' + (this.props.shade ? 'shade' : '')}>
		    <div className="container">
		        <div className="row">
		          <div className="col-md-4">
					<div className="visible-sm-inline visible-xs-inline">
						<h4>
							{this.props.label}<br />
							<small>{this.props.small}</small>
						</h4>
					</div>
					<div className="visible-md-inline visible-lg-inline" style={{'textAlign' : 'right'}}>
						<h4>
							{this.props.label}<br />
							<small>{this.props.small}</small>
						</h4>
					</div>
		          </div>
		          <div className="col-md-8">
					<div className="InnerFeatureContent">{this.props.children}</div>
		          </div>
		        </div>
		    </div>
		</div>
      </div>
    );
  }

  static ButtonContainer = class {
	
	render() {
		return (
			<div>
				<div style={{float: 'right', marginTop: '15px'}}>
					{this.props.children}		  			
				</div>
			</div>
		)
	}
  }
}

export default InnerFeature;



// WEBPACK FOOTER //
// ./src/content/InnerFeature.js